module.exports = __webpack_public_path__ + "static/media/open-sans-v27-latin-700.875ba548.woff2";